import { render, staticRenderFns } from "./our_services.vue?vue&type=template&id=8fdcafae&scoped=true&"
import script from "./our_services.vue?vue&type=script&lang=js&"
export * from "./our_services.vue?vue&type=script&lang=js&"
import style0 from "./our_services.vue?vue&type=style&index=0&id=8fdcafae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdcafae",
  null
  
)

export default component.exports